import React, { useState, useMemo } from "react"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import { deleteDoc, doc, getDoc } from "firebase/firestore"
import { db } from "../../Firebase/config"
import ReactSelect from "react-select"
import Notify from "../Componentslogic/Usenotifications"
import Spinner from "react-bootstrap/Spinner"
import { Modal, Button } from "react-bootstrap"
import ReactModal from "react-modal"
import StarRating from "./Starrating" // Assumes you have a StarRating component
import {
  FaWhatsapp,
  FaEye,
  FaChevronDown,
  FaChevronUp,
  FaFilter,
} from "react-icons/fa"
import UsefetchCollectionAdmin from "../Componentslogic/Usefetchcollection"

ReactModal.setAppElement("#root")
// Review Card Component (displays one review as a card)
export const AdminReviewsCard = ({ review }) => {
  const [show, setShow] = useState(false)
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false)
  const [showOrderModal, setShowOrderModal] = useState(false) // Order details modal state
  const [whatsAppMessage, setWhatsAppMessage] = useState("")
  const [selectedPhone, setSelectedPhone] = useState("")
  const [orderDetails, setOrderDetails] = useState(null) // Store order details
  const [cartExpanded, setCartExpanded] = useState(false)
  const [showDineInModal, setShowDineInModal] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const fetchOrderDetails = async () => {
    if (review.orderID) {
      try {
        const collectionName =
          review.type === "delivery" ? "DeliveryOrders" : "Orders"
        const orderDocRef = doc(db, collectionName, review.orderID) // Using orderNumber as the ID
        const orderSnapshot = await getDoc(orderDocRef)

        if (orderSnapshot.exists()) {
          setOrderDetails(orderSnapshot.data()) // Store order details

          if (review.type === "delivery") {
            setShowOrderModal(true)
          } else {
            setShowDineInModal(true)
          }
        } else {
          Notify("Order not found", "error")
        }
      } catch (error) {
        console.error("Error fetching order details:", error)
        Notify("Error fetching order details", "error")
      }
    } else {
      return
    }
  }

  const handleSendWhatsApp = () => {
    if (!whatsAppMessage.trim()) {
      Notify("Please enter a message", "error") // Ensure message isn't empty
      return
    }

    const message = encodeURIComponent(whatsAppMessage)
    const phoneNumber = selectedPhone.replace(/\D/g, "") // Remove any non-numeric characters

    // Detect if user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    // Use WhatsApp Web on desktop, WhatsApp App on mobile
    const whatsappUrl = isMobile
      ? `https://api.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Mobile opens WhatsApp App
      : `https://web.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Desktop opens WhatsApp Web

    window.open(whatsappUrl, "_blank") // Opens in new tab
    setShowWhatsAppModal(false) // Close modal after sending
  }

  const handleOpenWhatsAppModal = (phone) => {
    setSelectedPhone(phone)
    setWhatsAppMessage("") // Reset message input
    setShowWhatsAppModal(true)
  }

  const handleCloseWhatsAppModal = () => {
    setShowWhatsAppModal(false)
  }

  const handleDelete = async () => {
    try {
      // Here you would call your delete function from Firebase
      // For dummy data, we'll simply show a notification.
      Notify("Review deleted successfully", "success")
    } catch (error) {
      Notify("Error deleting review", "error")
    } finally {
      handleClose()
    }
  }

  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "N/A" // Handle missing timestamp

    const date = new Date(timestamp.seconds * 1000) // Convert Firestore Timestamp

    // Format date as YYYY-MM-DD
    const formattedDate = date.toLocaleDateString("en-GB")

    // Format time as HH:MM AM/PM
    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })

    return { formattedDate, formattedTime }
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the review from {review.useremail}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="mobile-review-card ">
        <p>
          <strong>Client Name:</strong> {review.userName || "No name provided"}
        </p>
        <p>
          <strong>Client Email:</strong>{" "}
          {review.useremail || "No email provided"}
        </p>
        <p>
          <strong>Comment:</strong> {review.text || "-"}
        </p>
        <p>
          <strong className="mb-2">Service Rating:</strong>{" "}
          <StarRating rating={review.ratingService} />
        </p>
        <p>
          <strong className="mb-2">Food Rating:</strong>{" "}
          <StarRating rating={review.ratingFood} />
        </p>
        <p>
          <strong>Date:</strong>{" "}
          {new Date(review.createdAt.seconds * 1000).toLocaleString() || "N/A"}
        </p>
        <div className="d-flex justify-content-center mt-3">
          {review.userPhone && (
            <FaWhatsapp
              size={24} // Adjust icon size
              color="green"
              className="whatsapp-icon mx-2"
              style={{ cursor: "pointer" }}
              onClick={() => handleOpenWhatsAppModal(review.userPhone)}
            />
          )}

          {review.orderID && (
            <FaEye
              size={24} // Adjust icon size
              color="Blue"
              className="whatsapp-icon mx-2"
              style={{ cursor: "pointer" }}
              onClick={() => fetchOrderDetails()}
            />
          )}
        </div>
      </div>
      <ReactModal
        isOpen={showWhatsAppModal}
        onRequestClose={handleCloseWhatsAppModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Send WhatsApp Message</h2>

        <div className="form-group mt-3">
          <label>Phone Number:</label>
          <input
            type="text"
            className="form-control"
            value={selectedPhone}
            disabled
          />
        </div>

        <div className="form-group mt-3">
          <label>Message:</label>
          <textarea
            className="form-control"
            rows="4"
            value={whatsAppMessage}
            onChange={(e) => setWhatsAppMessage(e.target.value)}
            placeholder="Type your message here..."
          ></textarea>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-secondary mx-2"
            onClick={handleCloseWhatsAppModal}
          >
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSendWhatsApp}>
            Send on WhatsApp
          </button>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={showOrderModal}
        onRequestClose={() => setShowOrderModal(false)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Order Details</h2>
        {orderDetails ? (
          <div className="order-details">
            <p>
              <b>Order Number:</b> {orderDetails.orderNumber}
            </p>
            <p>
              <b>Total Amount:</b> {orderDetails.totalAmount} EGP
            </p>
            <p>
              <b>Picked By:</b> {orderDetails.PickedBy || "N/A"}
            </p>
            <p>
              <b>Picked At:</b>{" "}
              {formatTimestamp(orderDetails.pickedAt).formattedDate},{" "}
              {formatTimestamp(orderDetails.pickedAt).formattedTime}
            </p>
            <p>
              <b>Delivered By:</b> {orderDetails.DeliveredBy || "N/A"}
            </p>
            <p>
              <b>Delivered At:</b>{" "}
              {formatTimestamp(orderDetails.deliveredAt).formattedDate},{" "}
              {formatTimestamp(orderDetails.deliveredAt).formattedTime}
            </p>
            <p>
              <b>Delivery Fee:</b> {orderDetails.deliveryFee || "N/A"} EGP
            </p>
            <p>
              <b>Area:</b> {orderDetails.address?.area}
            </p>

            {/* Cart Items - Collapsible */}
            <div className="cart-section">
              <div
                className="cart-header"
                onClick={() => setCartExpanded(!cartExpanded)}
              >
                <h6>Cart Items</h6>
                {cartExpanded ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {cartExpanded && (
                <div className="cart-items-container">
                  <ul>
                    {orderDetails.cart?.map((item, index) => (
                      <li key={index}>
                        <b>{item.name}</b> x {item.CartTotalQuantity} -{" "}
                        {item.itemTotal} EGP
                        <div className="item-options">
                          {item.spiceLevel && (
                            <span className="mx-2">
                              <b>Spice:</b> {item.spiceLevel}
                            </span>
                          )}
                          {item.combo && item.combo.name && (
                            <span>
                              <b>Combo:</b> {item.combo.name} -{" "}
                              {item.combo.Price} EGP
                            </span>
                          )}
                          {item.freeSauce && (
                            <span>
                              <b>Sauce:</b> {item.freeSauce}
                            </span>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p>Loading order details...</p>
        )}
        <button
          className="btn btn-secondary mt-3"
          onClick={() => setShowOrderModal(false)}
        >
          Close
        </button>
      </ReactModal>

      {/* ✅ Dine-in Order Modal */}
      <ReactModal
        isOpen={showDineInModal}
        onRequestClose={() => setShowDineInModal(false)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Dine-in Order Details</h2>
        {orderDetails ? (
          <div className="order-details">
            <p>
              <b>Order Number:</b> {orderDetails.ordernumber}
            </p>
            <p>
              <b>Total Amount:</b> {orderDetails.totalAmount} EGP
            </p>

            <p>
              <b>Placed At:</b>{" "}
              {formatTimestamp(orderDetails.PlacedAt).formattedDate},{" "}
              {formatTimestamp(orderDetails.PlacedAt).formattedTime}
            </p>
            <p>
              <b>Done At:</b> {orderDetails.DoneAttime}
            </p>

            {/* ✅ Collapsible Cart Items */}
            <div className="cart-section">
              <div
                className="cart-header"
                onClick={() => setCartExpanded(!cartExpanded)}
              >
                <h6>Cart Items</h6>
                {cartExpanded ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {cartExpanded && (
                <div className="cart-items-container">
                  <ul>
                    {orderDetails.cartItems?.map((item, index) => (
                      <li key={index}>
                        <b>{item.name}</b> x {item.CartTotalQuantity} -{" "}
                        {item.itemTotal} EGP
                        <div className="item-options">
                          {item.spiceLevel && (
                            <span className="mx-2">
                              <b>Spice:</b> {item.spiceLevel}
                            </span>
                          )}
                          {item.combo && item.combo.name && (
                            <span>
                              <b>Combo:</b> {item.combo.name} -{" "}
                              {item.combo.Price} EGP
                            </span>
                          )}
                          {item.freeSauce && (
                            <span>
                              <b>Sauce:</b> {item.freeSauce}
                            </span>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p>Loading order details...</p>
        )}
        <button
          className="btn btn-secondary mt-3"
          onClick={() => setShowDineInModal(false)}
        >
          Close
        </button>
      </ReactModal>
    </>
  )
}

// Main Reviews Container Component
const MobAdminReviewsContainer = () => {
  const {
    data: reviews,
    loading,
    nextPage,
    hasMore,
  } = UsefetchCollectionAdmin("Reviews")

  const [filterOption, setFilterOption] = useState(null)

  // Toggle the filter by clicking the icon
  const handleIconToggle = () => {
    if (!filterOption || filterOption.value === "lowest") {
      setFilterOption({ value: "highest", label: "Highest Rating" })
      Notify("Filter set to Highest Rating", "info")
    } else {
      setFilterOption({ value: "lowest", label: "Lowest Rating" })
      Notify("Filter set to Lowest Rating", "info")
    }
  }

  // Filtering reviews by rating option using useMemo
  const filteredReviews = useMemo(() => {
    if (!filterOption) return reviews
    const sortedReviews = [...reviews]
    if (filterOption.value === "highest") {
      sortedReviews.sort(
        (a, b) =>
          (b.ratingService + b.ratingFood) / 2 -
          (a.ratingService + a.ratingFood) / 2
      )
    } else if (filterOption.value === "lowest") {
      sortedReviews.sort(
        (a, b) =>
          (a.ratingService + a.ratingFood) / 2 -
          (b.ratingService + b.ratingFood) / 2
      )
    }
    return sortedReviews
  }, [reviews, filterOption])

  // Extraction to Excel function
  const handleExtract = async () => {
    if (reviews.length > 0) {
      const reviewsData = reviews.map((review, index) => ({
        id: index + 1,
        "Client-Name": review.userName,
        "Client-Email": review.useremail,
        Comment: review.text,
        "Service-Rating": review.ratingService,
        "Food-Rating": review.ratingFood,
        Date: new Date(review.createdAt.seconds * 1000).toLocaleString(),
      }))

      const worksheet = XLSX.utils.json_to_sheet(reviewsData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reviews")

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      })
      saveAs(blob, "reviews.xlsx")
      Notify("Extracted", "success")
    } else {
      Notify("No reviews to extract", "error")
    }
  }

  // Pagination: Display 2 review cards per page
  const itemsPerPage = 2
  const [currentPage, setCurrentPage] = useState(1)
  const totalPages = Math.ceil(filteredReviews.length / itemsPerPage)
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentReviews = filteredReviews.slice(
    indexOfFirstItem,
    indexOfLastItem
  )

  const filterOptions = [
    { value: "highest", label: "Highest Rating" },
    { value: "lowest", label: "Lowest Rating" },
  ]

  // Pagination arrow handlers
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1)
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1)
  }

  return (
    <div className="dashboard-container">
      <main className="main-content ">
        <header className="mobile-users-header">
          <div className="d-flex align-items-center justify-content-center ">
            <h2 className="mx-4">Total Reviews: {reviews.length} </h2>

            {/* Filter Icon that toggles highest/lowest */}
            <FaFilter
              style={{ cursor: "pointer" }}
              onClick={handleIconToggle}
            />
          </div>
        </header>

        {/* Pagination Controls with Arrow Buttons */}
        <div className="pagination-controls mb-3">
          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          {currentPage > 1 && (
            <button className="pagination-btn" onClick={handlePrevPage}>
              &#8592;
            </button>
          )}

          {currentPage < totalPages && (
            <button className="pagination-btn" onClick={handleNextPage}>
              &#8594;
            </button>
          )}
        </div>

        {/* Reviews rendered as vertical cards */}
        <section className="mobile-users-list">
          {currentReviews.map((review) => (
            <AdminReviewsCard key={review.id} review={review} />
          ))}
        </section>

        {loading && (
          <Spinner animation="grow" variant="primary" className="spinner">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </main>
    </div>
  )
}

export default MobAdminReviewsContainer
